import React from 'react';

import Loader from 'components/Loader';
import ItemPost from 'templates/pages/ResourceCenterPost';

import withPreview from '@/hoc/withPreview';
import { resourceCenterPost } from 'constants/graphql/resourceCenterPost';

const ResourceCenterPost = ({ pageContext, loaded, ...props }) => {
  if (!loaded) return <Loader />;

  return <ItemPost {...pageContext} {...props} />;
};

const queryPreview = `
query ResourceCenterQuery($id: ID = "") {
  resourceCenterPost(id: $id, idType: DATABASE_ID, asPreview: true) {
    ${resourceCenterPost()}
    revisions(first:1) {
      nodes {
        ${resourceCenterPost()}
      }
    }
  }
}
`;

export default withPreview(ResourceCenterPost, {
  queryPreview,
});
